// src/components/Services.js
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Leaf } from "lucide-react";
import { Link } from "react-router-dom";
import { serviceCategories } from "./serviceCategories";

const Services = () => {
  const [openCategory, setOpenCategory] = useState(null);

  const toggleCategory = (index) =>
    setOpenCategory(openCategory === index ? null : index);

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="container mx-auto px-4">
        {/* Título y descripción */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-green-600 mb-6">
            Tratamientos diseñados para tu Bienestar Integral
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
            En Bienestar al Natural, te ofrecemos terapias personalizadas que combinan técnicas modernas,
            soluciones innovadoras y acompañamiento profesional.
          </p>
        </motion.div>

        {/* Categorías de servicios */}
        <div className="max-w-6xl mx-auto space-y-8">
          {serviceCategories.map((category, index) => {
            const isOpen = openCategory === index;
            const Icon = category.icon;

            return (
              <motion.div
                key={category.title}
                className="bg-white p-6 rounded-3xl shadow-lg hover:shadow-2xl border border-gray-100 overflow-hidden transition-transform duration-300"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: index * 0.15 }}
                viewport={{ once: true }}
              >
                <div className="flex justify-between items-start">
                  <div className="flex items-start gap-4 flex-1 pr-4">
                    <div className="p-4 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl">
                      <Icon className="w-8 h-8 text-white" aria-hidden="true" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-800">{category.title}</h3>
                      <p className="text-gray-600 mt-1">{category.description}</p>
                    </div>
                  </div>

                  {/* Botón adaptativo */}
                  <button
                    onClick={() => toggleCategory(index)}
                    aria-expanded={isOpen}
                    aria-controls={`category-${index}`}
                    className={`flex items-center gap-2 mt-2 rounded-full font-semibold transition-all duration-300 shadow-md
                      px-3 py-1 text-sm
                      sm:px-4 sm:py-2 sm:text-sm
                      md:px-6 md:py-3 md:text-base
                      ${isOpen ? "bg-red-500 hover:bg-red-600 text-white" : "bg-green-500 hover:bg-green-600 text-white"}
                    `}
                  >
                    {/* Texto móvil */}
                    <span className="block md:hidden">{isOpen ? "Ocultar" : "Ver más"}</span>
                    {/* Texto tablet/desktop */}
                    <span className="hidden md:block">{isOpen ? "Ocultar" : category.buttonText}</span>
                    <motion.div initial={false} animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.3 }}>
                      <ChevronDown className="w-5 h-5" />
                    </motion.div>
                  </button>
                </div>

                {/* Lista de servicios */}
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      id={`category-${index}`}
                      className="pt-4"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
                    >
                      <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 text-gray-700 mt-4 pt-4 border-t border-gray-200">
                        {category.services.map((service) => (
                          <li key={service.url}>
                            <Link
                              to={service.url}
                              className="flex items-center gap-2 hover:text-green-700 transition duration-200 group"
                            >
                              <Leaf className="w-4 h-4 text-green-500 flex-shrink-0 group-hover:text-green-700" aria-hidden="true" />
                              <span className="truncate">{service.name}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;







